import styled from 'styled-components';

export const ServicoGrid = styled.div`
  display: grid;
  grid-gap: 30px;
  flex: 1;

  @media screen and (min-width: 800px) {
    display: flex;
  }

  @media screen and (max-width: 800px) {
    margin-bottom: 50px;
  }
`;

export const ServicoCabecalhoContainer = styled.div`
  text-align: center;
  padding: 15px;
  transition: 0.6s;
  display: grid;
  align-items: flex-start;

  :hover, :focus, :active {
    cursor: pointer;
  }
`;

export const ServicoCabecalhoTitulo = styled.h4`
  font-size: 1em;
  font-weight: 600;
  display: ${({ aberto }) => (aberto ? 'flex' : 'grid')};
  grid-gap: 10px;
  place-items: center;
  margin: 0;

  svg {
    width: ${({ aberto }) => (aberto ? '2.4' : '3.3')}em; 
  }

  > div {
    display: ${({ aberto }) => (aberto ? 'block' : 'grid')};
  }

  ${({ aberto }) => (aberto ? (
    `
      @media screen and (max-width: 800px) {
        display: grid;
      }
    `
  ) : '')}
`;

export const ServicoConteudoContainer = styled.div`
  background-color: #fbfaf5;
  border: 1px dashed #dededd;
  border-top: 0;
  border-radius: 0 0 10px 10px;
  padding: 10px;
  display: grid;
  grid-gap: 15px;
  user-select: text;
  }
`;

export const ServicoConteudoItem = styled.div`
  display: grid;
  min-height: 55.5px;
  
  @media screen and (min-width: 800px) {
    grid-template-columns: auto 1fr;
  }
`;

export const ServicoConteudoItemTitulo = styled.div`
  font-size: 0.9em;
  font-weight: 500;
  text-align: center;
  line-height: 1.3;
  padding: 8px;
  display: grid;
  align-items: center;

  @media screen and (min-width: 800px) {
    border-radius: 10px 0 0 10px;
    width: 7.8em;
  }
`;

export const ServicoConteudoItemValor = styled.div`
  font-size: 0.9em;
  background-color: #ffffff;
  border: 1px dashed #dededd;
  padding: 8px 15px;
  display: grid;
  align-items: center;

  p:first-child  {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  @media screen and (min-width: 800px) {
    border-left: 0;
    border-radius: 0 10px 10px 0;
  }
`;

export const ServicoContainer = styled.div`
  border-radius: 10px;
  overflow: hidden;
  display: grid;
  flex: 1;

  ${ServicoCabecalhoContainer} {
    background-color: ${({ corFundo }) => corFundo || 'rgb(222, 222, 221)'};
  }

  ${ServicoCabecalhoTitulo} {
    color: ${({ corFonte }) => corFonte || 'rgba(0, 0, 0, 0.7)'};

    svg {
      fill: ${({ corFonte }) => corFonte || 'rgba(0, 0, 0, 0.7)'};
    }
  }

  ${ServicoConteudoItemTitulo} {
    color: ${({ corFonte }) => corFonte || 'rgba(0, 0, 0, 0.7)'};
    background-color: ${({ corFundo }) => corFundo || 'rgb(222, 222, 221)'};
  }
`;
